import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import EventSegmentationFilters from 'automation-ui-enrollment/components/eventEnrollment/steps/EventSegmentationFilters';
import { jsx as _jsx } from "react/jsx-runtime";
const UI_MESSAGES = {
  // basically replaces 'filter' or 'trigger' with 'event'
  addFilterButtonLabel: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "automation-ui-action-features.action-features.wait-until.action-config.filters-component-overrides.add-filter"
  }),
  addFilterGroupButtonLabel: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "automation-ui-action-features.action-features.wait-until.action-config.filters-component-overrides.add-event"
  }),
  editFiltersButtonLabel: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "automation-ui-action-features.action-features.wait-until.action-config.filters-component-overrides.edit-events"
  }),
  editorAddFilterHeaderLabel: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "automation-ui-action-features.action-features.wait-until.action-config.filters-component-overrides.add-event"
  }),
  editorChangeFilterButtonTooltip: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "automation-ui-action-features.action-features.wait-until.action-config.filters-component-overrides.change-event-type"
  }),
  editorChangeFilterHeaderLabel: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "automation-ui-action-features.action-features.wait-until.action-config.filters-component-overrides.change-event"
  }),
  editorDeleteFilterButtonTooltip: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "automation-ui-action-features.action-features.wait-until.action-config.filters-component-overrides.delete-event"
  }),
  editorEditFilterHeaderLabel: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "automation-ui-action-features.action-features.wait-until.action-config.filters-component-overrides.edit-filter"
  }),
  filterSelectionBreadcrumbsSingleStep: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "automation-ui-action-features.action-features.wait-until.action-config.filters-component-overrides.select-event-add"
  }),
  filterSelectionBreadcrumbsStep1: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "automation-ui-action-features.action-features.wait-until.action-config.filters-component-overrides.select-event-delay"
  }),
  filteringObjectDropdownLabel: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "automation-ui-action-features.action-features.wait-until.action-config.filters-component-overrides.filtering-on"
  }),
  newFilterPlaceholderMessage: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "automation-ui-action-features.action-features.wait-until.action-config.filters-component-overrides.event-filter-placeholder"
  }),
  panelHeaderLabel: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "automation-ui-action-features.action-features.wait-until.action-config.filters-component-overrides.events"
  }),
  viewerEmptyFilters: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "automation-ui-action-features.action-features.wait-until.action-config.filters-component-overrides.empty-filter-placeholder"
  })
};
const WaitUntilSegmentationFilters = ({
  isEmbedded = false,
  triggers,
  objectTypeId,
  readOnly,
  onAreFiltersIncompleteChange = () => {},
  onChange = () => {},
  onFiltersEditorPanelOpenChange = () => {}
}) => {
  return /*#__PURE__*/_jsx("div", {
    style: {
      width: '100%'
    },
    children: /*#__PURE__*/_jsx(EventSegmentationFilters, {
      isEmbedded: isEmbedded,
      value: triggers,
      onAreFiltersIncompleteChange: onAreFiltersIncompleteChange,
      onChange: onChange,
      onFiltersEditorPanelOpenChange: onFiltersEditorPanelOpenChange,
      objectTypeId: objectTypeId,
      readOnly: readOnly,
      openInEditMode: !readOnly,
      uiMessagesOverrides: Object.assign({}, UI_MESSAGES, {
        // function must be called within a component
        filterCategorySearchInputPlaceholder: I18n.text('automation-ui-action-features.action-features.wait-until.action-config.filters-component-overrides.search-event-categories')
      })
    })
  });
};
export default WaitUntilSegmentationFilters;